import React from "react";
import { Container, Grid } from "@mui/material";

import Menu from '../../Components/Menu/MainMenu'
import page404 from './page404.png'
import pink from './pink.png'
import blue from './blue.png'

const PageNotFound = () => {
  return (
    <div className="MS---Header">
      <Menu />
      <div className="MS---404">
        <Container maxWidth="lg">
          <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className="py-5"
          >
              <Grid
                  xs={12}
                  className="text-center"
              >
                <img src={page404} style={{width: '100%', maxWidth: 500, height: 'auto'}} />
              </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
}

export default PageNotFound;
